import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import {
  camelCaseToUppercaseSentence,
  prettyPrintItem,
} from "../utils/stringManipulation";

interface Props {
  itemGetter: Function;
  itemId: number;
  dialogTitle: string;
  dialogOpen: boolean;
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
const DisplayItemDialog = ({
  itemGetter,
  itemId,
  dialogTitle,
  dialogOpen,
  setDialogOpen,
}: Props) => {
  const { data } = itemGetter({ id: itemId });
  if (data === undefined) return <></>;
  const handleClose = () => {
    setDialogOpen(false);
  };
  return (
    <Dialog fullWidth open={dialogOpen} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">{dialogTitle}</DialogTitle>
      <DialogContent>
        <Grid container direction="column">
          {Object.keys(data).map((key) => (
            <Grid item>
              <Grid container>
                <Grid item style={{ marginLeft: "1rem" }}>
                  <Typography
                    style={{ fontWeight: "bold" }}
                  >{`${camelCaseToUppercaseSentence(key)}: `}</Typography>
                </Grid>
                <Grid item style={{ marginLeft: ".7rem" }}>
                  <Typography>
                    {Array.isArray(data[key])
                      ? data[key].map((item: any) => (
                          <Typography style={{ marginLeft: "2rem" }}>
                            {prettyPrintItem(item)}
                          </Typography>
                        ))
                      : `${prettyPrintItem(data[key])}`}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DisplayItemDialog;
